export { default as CatalogoEmpregado } from './apresentacao/CatalogoEmpregado.vue'
export { usarCatalogoEmpregado } from './apresentacao/usar-catalogo-empregado'
export {
  CHAVE_OPERACOES_CATALOGO_EMPREGADO,
  usarOperacoesCatalogoEmpregado,
} from './apresentacao/catalogo-empregado.injecao'
export { DESCRITOR_CATALOGO_EMPREGADO } from './catalogo-empregado.tipos'
export type {
  FiltrosCatalogoEmpregado,
  OpcaoEmpregado,
  OperacoesCatalogoEmpregado,
  SelecaoCatalogoEmpregado,
} from './catalogo-empregado.tipos'
